import { render, staticRenderFns } from "./DeleteAnnonceDialog.vue?vue&type=template&id=508dc590"
import script from "./DeleteAnnonceDialog.vue?vue&type=script&lang=js"
export * from "./DeleteAnnonceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports